<template>
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->
  <div class="layout">
    <div class="box-layout" style="padding: 25px 17px 25px 17px;width:413px;">
      <div class="box-title">
        <div style="display:flex;flex-direction: row;gap:8px; ">
          <typography
            h5
            :label="$t('รูปแบบที่ ') + `${intent_index + 1}`"
            :bold="true"
          ></typography>
          <span class="tooltip">
            <img src="/static/img/assets/help/h_choice.svg" style="cursor: pointer;" />
            <span class="tooltiptext">
              กรณีผู้ใช้ต้องการสุ่มคำตอบให้แต่ละครั้งมีความแตกต่าง กันออกไป กรุณาคลิกปุ่ม “+”
              ที่ด้านขวาล่าง
            </span>
          </span>
        </div>
        <div>
          <img @click="toggleModalSetting" src="/static/img/assets/welcome/setting-chatbot.svg" style="cursor: pointer;" />
          <v-dialog v-model="modalSetting">
            <div class="modal" style="height: 810px;width: 380px;" v-if="modalSetting">
              <div
                style="display:flex;flex-direction: row;justify-content: space-between;width:100%;"
              >
                <typography h2 :label="$t('ตั้งค่าบทสนทนา')" :bold="true"></typography>
                <img
                  src="/static/img/assets/welcome/X.svg"
                  class="close-icon"
                  @click="toggleModalSetting"
                  style="height:24px;weight:24px;"
                />
              </div>
              <div style="width:100%;">
                <div style="margin-top: 40px;">
                  <typography h3 :label="$t('สถานะและป้ายกำกับ')" :bold="true"></typography>
                  <typography h6 :label="$t('สถานะ')" style="margin-top: 14px;"></typography>
                  <input
                    v-model="welcome_intent.userstatus"
                    class="button-inputButtonType"
                    style="margin-top: 8px;"
                  />
                  <typography h6 :label="$t('ป้ายกำกับ')" style="margin-top: 14px;"></typography>
                  <div
                    style="display:flex;flex-wrap: wrap; gap:2px;background: #FFFFFF;border: 0px solid #0C2F53;border-radius: 0px;padding: 0px; "
                  >
                    <div v-for="(item, index) in tagUser" :key="index">
                      <ChatbotBoxMessage
                        :item="item"
                        :index="index"
                        @changUserTag="changUserTag"
                        @removieUserTag="removieUserTag"
                      ></ChatbotBoxMessage>
                    </div>
                    <div>
                      <template v-if="isAddUserTag">
                        <div class="tag-box-edit">
                          <div
                            style="display: flex;flex-direction: row;gap: 4px;align-items: center;"
                          >
                            <input
                              v-model="newUserTag"
                              class="input-box"
                              :required="true"
                              type="text"
                              style="height:20px"
                            />
                            <div @click="summitNewUserTag">
                              <img src="/static/img/assets/welcome/correct.svg" />
                            </div>
                            <div @click="toggleIsAddUserTag">
                              <img src="/static/img/assets/welcome/X.svg" />
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="tag-box">
                          <div
                            style="display: flex;flex-direction: row;gap: 4px;align-items: center;cursor:default;"
                            @click="toggleIsAddUserTag"
                          >
                            <typography :label="`+ เพิ่ม`" color="rgba(189, 189, 189, 1)" />
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- <div
                    style="display:flex;flex-wrap: wrap; gap:2px;background: #FFFFFF;border: 1px solid #0C2F53;border-radius: 6px;padding: 8px 12px; "
                  >
                    <div v-for="(item, index) in tagUser" :key="index">
                      <ChatbotBoxMessage
                        :item="item"
                        :index="index"
                        @changUserTag="changUserTag"
                        @removieUserTag="removieUserTag"
                      ></ChatbotBoxMessage>
                    </div>
                    <div>
                      <template v-if="isAddUserTag">
                        <div class="tag-box-edit">
                          <div
                            style="display: flex;flex-direction: row;gap: 4px;align-items: center;"
                          >
                            <input
                              v-model="newUserTag"
                              class="input-box"
                              :required="true"
                              type="text"
                              style="height:20px"
                            />
                            <div @click="summitNewUserTag">
                              <img src="/static/img/assets/welcome/correct.svg" />
                            </div>
                            <div @click="toggleIsAddUserTag">
                              <img src="/static/img/assets/welcome/X.svg" />
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="tag-box">
                          <div
                            style="display: flex;flex-direction: row;gap: 4px;align-items: center;cursor:default;"
                            @click="toggleIsAddUserTag"
                          >
                            <typography :label="`+ เพิ่ม`" color="rgba(189, 189, 189, 1)" />
                          </div>
                        </div>
                      </template>
                    </div>
                  </div> -->
                </div>
                <div style="margin-top:16px; border-bottom: 1px solid rgba(217, 217, 217, 1)"></div>
                <div style="margin-top: 40px;">
                  <typography h3 :label="$t('สถานะ')" :bold="true"></typography>
                  <typography h6 :label="$t('Context In')" style="margin-top: 14px;"></typography>
                  <input
                    v-model="welcome_intent.context_in"
                    class="button-inputButtonType"
                    style="margin-top: 8px;"
                  />
                  <typography h6 :label="$t('Context Out')" style="margin-top: 14px;"></typography>
                  <input
                    v-model="welcome_intent.context_out"
                    class="button-inputButtonType"
                    style="margin-top: 8px;"
                  />
                </div>
                <div style="margin-top:16px; border-bottom: 1px solid rgba(217, 217, 217, 1)"></div>
                 <div style="margin-top: 40px;">
                  <typography h3 :label="$t('ช่วงเวลาตอบ')" :bold="true"></typography>

                  <typography h6 :label="$t('วัน-เวลาเปิด')" style="margin-top: 14px;"></typography>
                  <div style="width: 100%" class="form-control">
                    <date-picker
                      v-model="startDate"
                      type="datetime"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      @close="handleOpenChange"
                      format="DD/MM/YYYY HH:mm"
                      :append-to-body="false"
                    >
                      <template v-slot:footer="{ emit }">
                        <div
                          style="display:flex;flex-direction: row;justify-content: space-between;"
                        >
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>

                  <typography h6 :label="$t('วัน-เวลาปิด')" style="margin-top: 14px;"></typography>
                  <div style="width: 100%" class="form-control">
                    <date-picker
                      v-model="endDate"
                      type="datetime"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      @close="handleOpenChange"
                      format="DD/MM/YYYY HH:mm"
                      :append-to-body="false"
                    >
                      <template v-slot:footer="{ emit }">
                        <div
                          style="display:flex;flex-direction: row;justify-content: space-between;"
                        >
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <div style="margin-top:16px; border-bottom: 1px solid rgba(217, 217, 217, 1)"></div>
                <div style="margin-top: 40px;">
                  <div
                    style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;"
                  >
                    <typography h3 :label="$t('แจ้งเตือนผ่าน LINE')" :bold="true"></typography>
                    <div>
                      <toggle-button
                        v-model="welcome_intent.linenoti_status"
                        :width="53"
                        :height="25"
                        :sync="true"
                        :color="{ checked: '#52C41A', unchecked: '#BDBDBD', disabled: '#CCCCCC' }"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                        style="display: inline-block; font-size: 12px;text-align: left;"
                      />
                      <!-- <label
                          class="toggle-switch small"
                          style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                        >
                        <input
                          type="checkbox"
                          :checked="welcome_intent.linenoti_status"
                          @change="toggleLineNotifyStatus"
                        />
                        <span class="toggle-slider lever round"></span>

                      </label> -->
                    </div>
                  </div>
                  <typography h6 :label="$t('ข้อความ')" style="margin-top: 14px;"></typography>
                  <input
                    v-model="welcome_intent.linenoti_text"
                    class="button-inputButtonType"
                    style="margin-top: 8px;"
                  />
                </div>
                <div style="margin-top:16px; border-bottom: 1px solid rgba(217, 217, 217, 1)"></div>
              </div>

              <div class="btn-footer" style="margin-top: 56px;">
                <v-btn class="btn-cancel" @click="toggleModalSetting">
                  ยกเลิก
                </v-btn>
                <v-btn class="btn-summit" @click="settingSummit">
                  ยืนยัน
                </v-btn>
              </div>
            </div>
          </v-dialog>
        </div>
      </div>
      <template v-if="answers">
        <div style="display: flex;flex-direction: column;justify-content: center;">

          <draggable
            v-model="answers[intent_index]"
            @start="drag=true"
            :move="checkLoad"
            @end="onMoveCallback"
          >
            <div
              v-for="(message, index) in answers[intent_index]"
              style="margin-bottom: 5px;width: 241px;"
            >
              <chatbot-box
                :message="message"
                :keyIndex="index"
                :intent_index="intent_index"
                :answers="answers"
                :type="message.type"
                @getWelcomeMessage="$emit('getWelcomeMessage')"
                @changIntentIndex="changIntentIndex"
              >
              </chatbot-box>
            </div>

          </draggable>
        </div>
      </template>
      <template v-else>
        <div
          style="display: flex;flex-direction: column;justify-content: center;align-items: center;"
        >
          <img
            src="/static/img/assets/welcome/empty-chatboxMessage.svg"
            style="width:80px;height: 80px;margin-bottom:24px;"
          />
          <typography h3 bold7 :label="$t('รูปแบบนี้ยังไม่มีโมดูล')" :bold="true"></typography>
          <typography
            h6
            bold5
            :label="$t('กรุณาคลิกโมดูลด้านขวามือเพื่อเพิ่มลงในตัวอย่าง')"
            :medium="true"
          ></typography>
        </div>
      </template>
      <div style="margin-top:16px; border-bottom: 1px solid rgba(217, 217, 217, 1)"></div>
      <div style="margin-top:30px;display:flex;justify-content: flex-end;align-items: end;gap:8px;">
        <div v-for="(data, index) in answers">
          <PaginationChatbot
            :key="index"
            :answers="answers"
            :data="data"
            :index="index"
            :intent_index="intent_index"
            @changIntentIndex="changIntentIndex"
          ></PaginationChatbot>
        </div>
        <template v-if="answers.length < 5">
          <div
            style="width: 32px !important; height: 32px !important; border-radius: 5px !important; background: #FFFFFF !important; border: 1px solid #BDBDBD !important; display: flex; justify-content: center; align-items: center;cursor: pointer;"
            @click="toggleModalNewAnswers"
          >
            <div style="color: #BDBDBD;font-weight: 400;font-size: 14px;cursor: default;">+</div>
          </div>
          <v-dialog v-model="modalAddNewAnswers">
            <div class="modal" style="width: 520px;" v-if="modalAddNewAnswers">
              <div
                style="display:flex;flex-direction: row;justify-content: space-between;width:100%;"
              >
                <div>
                  <typography h2 :label="$t('เพิ่มรูปแบบ')" :bold="true"></typography>
                  <typography
                    h5
                    :label="$t('กรุณาเลือกโมดูลที่ต้องการเพิ่มในรูปแบบใหม่')"
                  ></typography>
                </div>
                <img
                  src="/static/img/assets/welcome/X.svg"
                  class="close-icon"
                  @click="toggleModalNewAnswers"
                  style="position: absolute;right: 30px;height: 24px;width: 24px;"
                />
              </div>
              <div
                style="display:flex;flex-direction: row;flex-wrap: wrap; justify-content: flex-start;gap:20px;padding-top:24px;"
              >
                <div v-for="(data, index) in this.addChat">
                  <BoxAddNewAnswers
                    :answers="answers"
                    :data="data"
                    :key="index"
                    :intent_index="intent_index"
                    :value="answers[intent_index]"
                    :toggleModalNewAnswers="toggleModalNewAnswers"
                    @closeModalAddNewAnswers="closeModalAddNewAnswers"
                    @changIntentIndex="changIntentIndex"
                    @getWelcomeMessage="$emit('getWelcomeMessage')"
                  ></BoxAddNewAnswers>
                </div>
              </div>
            </div>
          </v-dialog>
        </template>
      </div>
    </div>

    <div class="box-layout" style="background-color: #E6F0FB;max-width: 450px;">
      <div class="phone-graphic">
        <div class="phone-container-outer">
          <div class="phone-container-inner">
            <div class="phone-header">
              <p class="phone-header-time">1:02</p>
              <p class="phone-header-icons">
                <span class="material-icons">signal_cellular_alt</span>
                <span class="material-icons">wifi</span>
                <span class="material-icons battery">battery_std</span>
              </p>
              <div class="contact-phone">
                <div>
                  <img
                    src="/static/img/assets/welcome/ArrowBackwhite.svg"
                    class="depa-icon"
                    style="border-radius: 100%;width: 16px;height: 16px;"
                  />
                </div>
                <div>
                  <img
                    src="/static/img/assets/welcome/OfficialLine.svg"
                    class="depa-icon"
                    style="border-radius: 100%;width: 16px;height: 16px;"
                  />
                  depaThailand
                </div>
                <div>
                  <img
                    src="/static/img/assets/welcome/Homewhite.svg"
                    class="depa-icon"
                    style="border-radius: 100%;width: 16px;height: 16px;"
                  />
                  <img
                    src="/static/img/assets/welcome/ArrowDownwhite.svg"
                    class="depa-icon"
                    style="border-radius: 100%;width: 16px;height: 16px;"
                  />
                </div>
              </div>
            </div>

            <div class="phone-messages" style="overflow-y: scroll; padding-bottom: 80px;">
              <div
                v-for="(message, index) in answers[intent_index]"
                :key="'answer_message_' + index"
                :id="'answer_message_' + index"
                style="margin-bottom: 5px"
              >
                <template v-if="message.type === 'text'">
                  <div style="display:flex; flex-direction: row;gap:20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div class="message message-contact" style="padding:13px">
                      <div>
                        <typography :label="message.text" :color="color - darkGrey"></typography>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="message.type === 'button'">
                  <div style="display:flex; flex-direction: row;gap:20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div class="message message-contact" style="padding:13px">
                      <div style="display: flex;flex-direction: column;gap:10px;">
                        <typography :label="message.text" :color="color - darkGrey"></typography>
                        <template v-for="(button, index) in message.buttons">
                          <div class="button-editButton">
                            <div style="color: #FFFFFF;font-weight: 700;font-size: 16px;">
                              {{ button.title }}
                            </div>
                          </div>
                          <div>
                            <span
                              style="cursor: pointer;display: flex;justify-content: center;"
                              v-clipboard:copy="button.title"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onCopyError"
                            >
                              {{  (button.url || button.payload || '').slice(0, 30)  }}
                            </span>
                            <hr />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="message.type === 'image'">
                  <div style="display:flex; flex-direction: row;gap:20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div>
                      <image-type :value="message.image_url" :align="align"></image-type>
                    </div>
                  </div>
                </template>
                <template v-if="message.type == 'video'">
                  <div style="display:flex; flex-direction: row;gap:20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div>
                      <div v-if="message.source">
                        <div v-if="message.source.indexOf('//api') != -1">
                          <video width="100%" controls style="border-radius: 16px">
                            <source :src="message.source" type="video/mp4" />
                          </video>
                        </div>
                        <div v-else-if="message.source.indexOf('youtube') != -1">
                          <LazyYoutube maxWidth="720px" :src="message.source" />
                        </div>
                      </div>
                      <div v-else-if="message.sourceline">
                        <div v-if="message.sourceline.indexOf('//api') != -1">
                          <video width="100%" controls style="border-radius: 16px">
                            <source :src="message.sourceline" type="video/mp4" />
                          </video>
                        </div>
                        <div v-else-if="message.sourceline.indexOf('youtube') != -1">
                          <LazyYoutube maxWidth="720px" :src="message.sourceline" />
                        </div>
                      </div>
                    </div>

                  </div>
                </template>
                <template v-else-if="message.type == 'generic'">
                  <div style="display:flex; flex-direction: column;">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div
                      style="display:flex;flex-direction: row;overflow-x: auto;padding-bottom: 16px;"
                    >
                      <template v-for="(data, index) in message.data">
                        <div class="generic-Card">
                          <div style="width: 100%;">
                            <div
                              v-if="data.image_url"
                              :style="{
                                height:
                                  '216' /
                                    (ratio == 'horizontal' ? 1.91 : 1) +
                                  'px',
                                'background-image': 'url(\'' + data.image_url + '\')'
                              }"
                              style="
                              width: 241px;
                              height: 216px;
                              background-size: cover;
                              background-position: center;
                              background-repeat: no-repeat;
                              border-top-right-radius: 15px;
                              border-top-left-radius: 15px;
                            "
                            ></div>
                            <div v-else
                            style="
                              width: 241px;
                              height: 216px;
                              display: flex;
                              align-items:center;
                              justify-content: center;
                              border-top-right-radius: 15px;
                              border-top-left-radius: 15px;"
                            >
                              <img
                                src="/static/img/assets/welcome/imagedefault.svg"
                                class="depa-icon"
                                style="
                                width: 118px;
                                height: 122px;
                                background-size: cover;
                                background-position: center;
                                background-repeat: no-repeat;
                                border-top-right-radius: 15px;
                                border-top-left-radius: 15px;"
                              />
                            </div>
                          </div>
                          <div
                            style="display: flex;flex-direction: column;justify-content: center;margin-top: 4px;width: 100%;padding:10px"
                          >
                            <div
                              style="width:220px; margin-bottom: 6px;font-weight: 700;font-size: 16px;color: #252525;"
                            >
                              {{ data.title }}
                            </div>
                            <div
                              style="width:220px; margin-bottom: 6px;margin-top:14px;font-weight: 500;font-size: 16px;color: #252525;"
                            >
                              {{ data.subtitle }}
                            </div>
                            <div
                              style="display:flex;flex-direction: column;gap:10px; justify-content: center;align-items: center;"
                            >
                              <template v-for="(item, idx) in data.buttons">
                                <div class="button-editButton">
                                  <div
                                    style="color: #FFFFFF;font-weight: 700;font-size: 16px;width:100%;display: flex;justify-content: center;"
                                  >
                                    {{ item.title }}
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- <generic-viewer
                  v-model="message.data"
                  :size="size"
                  :align="align"
                  :ratio="message.ratio"
                ></generic-viewer> -->
                </template>
                <template v-else-if="message.type == 'flex'">
                  <div style="display:flex; flex-direction: column;">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div
                      class="text-xs-center pa-2"
                      style="border: 1px solid #eee; border-radius: 10px"
                      :style="{ float: align }"
                    >
                      <vue-simple-svg
                        :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                        width="40px"
                        height="40px"
                        class="img"
                        :fill="$vuetify.theme.primary"
                      />
                      <div class="primary--text caption">Line Flex Message</div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </template>
                <template v-if="message.type === 'sticker'">
                  <div style="display:flex; flex-direction: column;">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%;width: 32px;height: 32px;"
                      />
                    </div>
                    <div style="max-width: 200px;padding-left: 20px;">
                      <v-img
                        aspect-ratio="1"
                        :src="
                          `/static/img/assets/stickers/${message.packageid}/${
                            message.stickerid
                          }.png`
                        "
                        :lazy-src="
                          `/static/img/assets/stickers/${message.packageid}/${
                            message.stickerid
                          }.png`
                        "
                        style="width: 100%"
                      >
                        <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </div>
                </template>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="phone-footer">
              <div class="phone-footer-icons"><span class="material-icons">photo_camera</span></div>
              <div class="phone-footer-input">
                <p>Text Message</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Copied') }}!</v-snackbar
      >
    </div>

    <div class="box-layout" style="padding: 25px 17px 25px 17px;width:160px;">
      <div style="font-weight: 700;font-size: 18px;color: #0C2F53;">
        เพิ่มโมดูล ({{ (answers[intent_index]|| []).length }}/5)
      </div>
      <div
        style="display:flex;flex-direction: column;justify-content: flex-start;gap:20px;margin-top:24px"
      >
        <div v-for="(data, index) in this.addChat">
          <BoxAddChatbot
            :answers="answers"
            :data="data"
            :key="index"
            :intent_index="intent_index"
            :value="answers[intent_index]"
            @getWelcomeMessage="$emit('getWelcomeMessage')"
          ></BoxAddChatbot>
        </div>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import api from '@/api'
import config from '@/config' // config.serverUrl
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import ImageType from './ImageType'
import Typography from '../../elements/Typography.vue'
import ChatbotBox from './ChatbotBox.vue'
import ChatbotBoxMessage from './ChatbotBoxMessage.vue'
import BoxAddChatbot from './BoxAddChatbot.vue'
import BoxAddNewAnswers from './BoxAddNewAnswers.vue'
import PaginationChatbot from './PaginationChatbot.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import draggable from 'vuedraggable'
import { ToggleButton } from 'vue-js-toggle-button'
import { LazyYoutube } from 'vue-lazytube'
export default {
  name: 'message-viewer',
  props: {
    value: [Object, String, Array],
    background: {
      type: String,
      default: '#F1F0F0'
    },
    color: {
      type: String,
      default: 'black'
    },
    showDeep: {
      type: Boolean,
      default: true
    },
    size: {
      default: 'big'
    },
    showProfile: {
      default: false,
      type: Boolean
    },
    align: {
      default: 'left'
    },
    welcome_intent: {
      type: Object
    }
  },
  data: function() {
    return {
      group: this.value,
      intent_index: 0,
      showCopy: false,
      addChat: [
        {
          title: 'ข้อความ',
          image: '/static/img/assets/welcome/TypeAddText.svg',
          type: 'text'
        },
        {
          title: 'ปุ่มกด',
          image: '/static/img/assets/welcome/TypeAddButton.svg',
          type: 'button'
        },
        {
          title: 'รูปภาพ',
          image: '/static/img/assets/welcome/TypeAddImage.svg',
          type: 'image'
        },
        {
          title: 'วีดิโอ',
          image: '/static/img/assets/welcome/TypeAddVideo.svg',
          type: 'video'
        },
        {
          title: 'ลิสต์เมนู',
          image: '/static/img/assets/welcome/TypeAddListMenu.svg',
          type: 'generic'
        },
        {
          title: 'Flex Message',
          image: '/static/img/assets/welcome/TypeAddFlexMessage.svg',
          type: 'flex'
        },
        {
          title: 'Line Sticker',
          image: '/static/img/assets/welcome/TypeAddLineSticker.svg',
          type: 'sticker'
        }
      ],
      modalAddNewAnswers: false,
      modalSetting: false,
      settingStatus: '',
      settingLabel: '',
      tagUser: [],
      isAddUserTag: false,
      newUserTag: '',
      startDate: '',
      endDate: '',
      dragLoad: true,
    }
  },
  components: {
    specialtext,
    GenericViewer,
    IntentGetstarted,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ImageType,
    ChatbotBox,
    BoxAddChatbot,
    ChatbotBoxMessage,
    BoxAddNewAnswers,
    PaginationChatbot,
    Typography,
    DatePicker,
    draggable,
    ToggleButton,
    LazyYoutube,
  },
  mounted: function() {
    var vm = this
    this.startDate = moment(this.welcome_intent.starttime).toDate()
    this.endDate = moment(this.welcome_intent.endtime).toDate()
    this.tagUser = this.welcome_intent.usertags.split(',')
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage'
    }),
    answers: function() {
      var vm = this
      if (vm.group == null) {
        return []
      }
      var messagelist = []
      $.each(vm.value, function(index, group) {
        var newGroup = []
        $.each(group, function(mindex, message) {

          if (message[0]) {
            message = message[0]
          }
          if (
            (message.type === 'text' && message.text !== '') ||
            (message.type === 'button' &&
              message.buttons &&
              (message.buttons.length > 0 || message.text !== '')) ||
            (message.type === 'image' && message.image_url !== '' && message.image_url !== null) ||
            message.type === 'welcome_message' ||
            (message.type === 'flex' && message.contents !== '') ||
            (message.type === 'payment' && message.detail !== '') ||
            (['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type) &&
              message.detail !== '')
          ) {
            newGroup.push(message)
          } else if (message.type === 'generic') {
            var generics = []
            $.each(message.data, function(gindex, g) {
              if (
                g.title !== '' ||
                g.subtitle !== '' ||
                g.buttons.length > 0 ||
                (g.image_url !== '' && g.image_url != null) ||
                (typeof g.productid != 'undefined' && g.productid != null)
              ) {
                generics.push(g)
              }
            })
            if (generics.length > 0) {
              newGroup.push({
                type: 'generic',
                data: generics,
                ratio: message.ratio == 'horizontal' ? 'horizontal' : 'square'
              })
            }
          } else if (message.type === 'responsepost') {
            if (vm.showProfile) {
              if (
                message.replyinbox === true &&
                message.responseinbox[0].text !== '' &&
                message.responseinbox[0].text !== null
              ) {
                newGroup.push(message)
              }
            } else {
              if (
                (message.replyinbox === true &&
                  message.responseinbox[0].text !== '' &&
                  message.responseinbox[0].text !== null) ||
                (message.replycomment === true &&
                  message.responsecomment[0].text !== '' &&
                  message.responsecomment[0].text !== null) ||
                message.hidecomment === true
              ) {
                newGroup.push(message)
              }
            }
          } else if (['video', 'audio', 'imagemap', 'sticker', 'file'].includes(message.type)) {
            newGroup.push(message)
          }
        })
        if (newGroup.length > 0) {
          messagelist.push(newGroup)
        }
      })
      if (messagelist.length === 0) {
        messagelist = [[]]
      }
      vm.group = messagelist
      vm.genFlexMessage()

      return vm.group
      // try {
      // var group_messages = vm.group.split('||')
      // $.each(group_messages,function(index, messages){
      //     var messages = messages.split('#nl')
      //     var newMessages = []
      //     $.each(messages, function(inedx, message){
      //         if (vm.isURL(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'image',
      //                     value: message
      //                 }
      //             )
      //         } else if (!isNaN(message)) {
      //             newMessages.push({
      //                 type: 'text',
      //                 value: {
      //                     text: message,
      //                     buttons: []
      //                 }
      //             })
      //         } else if(vm.isJsonParseable(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: JSON.parse(message)
      //                 }
      //             )
      //         } else {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: {
      //                         text: message,
      //                         buttons: []
      //                     }
      //                 }
      //             )
      //         }
      //     })
      //     group.push(newMessages)
      // })
      // } catch (error) {
      //     // console.log(vm.group)
      // }
    }
  },
  methods: {
    onMoveCallback(evt) {
      let vm = this
      const indexBefore = evt.oldIndex // index ก่อนที่จะย้ายข้อมูลไปหลัง
      const indexAfter = evt.newIndex // index หลังที่จะย้ายข้อมูลไป
      let newAnswers = this.answers
      const removedNewAnswers = newAnswers[this.intent_index].splice(indexBefore, 1)[0]
      newAnswers[this.intent_index].splice(indexAfter, 0, removedNewAnswers)
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json'
      }
      this.dragLoad = false
      var messages = []
      data['message'] = JSON.stringify(newAnswers)
      api.saveWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        vm.cached_type = vm.type
        vm.cached_messages = JSON.stringify(messages)
        vm.bubbleMessages = messages
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages
        })

        vm.isEditWelcome = false

        if (response) {
          vm.$emit('getWelcomeMessage')
        }
      })
      vm.$forceUpdate()
    },
    checkLoad(){
      return this.dragLoad
    },
    toggleModalNewAnswers() {
      this.modalAddNewAnswers = !this.modalAddNewAnswers
    },
    closeModalAddNewAnswers(){
      this.modalAddNewAnswers = false
    },
    toggleModalSetting() {
      this.modalSetting = !this.modalSetting
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel
    },
    changIntentIndex(index) {
      this.intent_index = index
      console.log('this.intent_index', this.intent_index)
      this.$forceUpdate()
    },
    changUserTag(value, index) {
      this.tagUser[index] = value
    },
    removieUserTag(index) {
      this.tagUser.splice(index, 1)
    },
    toggleIsAddUserTag() {
      this.isAddUserTag = !this.isAddUserTag
      this.newUserTag = ''
    },
    summitNewUserTag() {
      if (this.newUserTag.includes(',')) {
        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายจุลภาค (,) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px'
        })
        return
      }
      if (this.newUserTag.includes('(')) {
        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายวงเล็บ ( ) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px'
        })
        return
      }
      if (this.newUserTag.includes(')')) {
        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายวงเล็บ ( ) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px'
        })
        return
      }
      if (this.newUserTag === '') {
        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> กรุณากรอกข้อความ </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px'
        })
        return
      }
      this.tagUser.push(this.newUserTag)
      this.toggleIsAddUserTag()
    },
    genFlexMessage() {},
    linemessagecontenttypefile(messageid) {
      var vm = this
      let pdfWindow = window.open(
        `${config.serverUrl}linemessagecontenttypefile?pageid=${
          this.selectedBot.pageid
        }&messageid=${messageid}`
      )
    },
    goLinkBtn(link) {
      window.location.assign(link)
    },
    updateQueryString(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') != -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
    onCopy: function() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    addNewAnswers: function() {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json'
      }
      vm.$store.dispatch('loading')
      const arr = [{}]
      this.value.push(arr)
      data['message'] = JSON.stringify(this.answers)
      //data['message'] = `[[{\"text\":\"one1\",\"type\":\"text\"},{\"text\":\"one2\",\"type\":\"text\"}],[{\"text\":\"two1\",\"type\":\"text\"},{\"text\":\"two2\",\"type\":\"text\"}],[]]`
      api.saveWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.cached_type = vm.type
        vm.cached_messages = JSON.stringify(messages)
        vm.bubbleMessages = messages
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages
        })

        vm.isEditWelcome = false
        vm.$store.dispatch('loading')
      })
    },
    toggleLineNotifyStatus: function() {
      this.welcome_intent.linenoti_status = !this.welcome_intent.linenoti_status
    },
    saveIntent: function() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: this.welcome_intent.intentname,
        q_type: this.welcome_intent.q_type,
        q_val: this.welcome_intent.q_val,
        a_type: 'json',
        a_val: this.welcome_intent.a_val,
        ispriority: this.welcome_intent.ispriority,
        quick_reply: this.welcome_intent.quick_reply,
        postidlist: this.welcome_intent.postidlist,
        exceptpostidlist: this.welcome_intent.exceptpostidlist
          ? this.welcome_intent.exceptpostidlist
          : '',
        isShow: true,
        intentstatus: this.welcome_intent.intentstatus ? this.welcome_intent.intentstatus : false,
        onlytime: this.welcome_intent.onlytime ? this.welcome_intent.onlytime : false,
        intentgroup: this.welcome_intent.intentgroup ? this.welcome_intent.intentgroup : null
      }
      if (vm.selectedBot.theme == 'ticket') {
        data.intentgroup = this.welcome_intentgroup
      }

      if (this.showMultipleChannel) {
        data.fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        data.line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
      }
      this.welcome_intent.usertags = this.tagUser.join(',')
      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in =
          this.welcome_intent.context_in != null ? this.welcome_intent.context_in : ''
        data.context_out =
          this.welcome_intent.context_out != null ? this.welcome_intent.context_out : ''
        data.userstatus = this.welcome_intent.userstatus
        data.usertags = this.welcome_intent.usertags
        data.linenoti_status = this.welcome_intent.linenoti_status
        data.linenoti_text = this.welcome_intent.linenoti_text
        // data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null
        data.starttime = moment(this.startDate).isValid() === false ? null : this.startDate ? moment(this.startDate).format() : null
        data.endtime = moment(this.endDate).isValid() === false ? null :this.endDate ? moment(this.endDate).format() : null
        // data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = vm.remaining_reply == false ? null : vm.remaining_reply
          data.notreplysameperson = vm.notreplysameperson
        }
      } else {

        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.userstatus = vm.cached_intent.userstatus
        data.usertags = vm.cached_intent.usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = null
          data.notreplysameperson = false
        }
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          // var messages = vm.checkEmptyMessage(vm.messages)

          // data.a_val = JSON.stringify(messages)
          data.a_val = this.welcome_intent.a_val
        }
      }
      vm.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }

          if (!this.welcome_intent.id) {
            vm.$store.dispatch('loading')
            api.addIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              data.id = response.id
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.$emit('close', null)
              vm.$store.dispatch('loading')
              this.welcome_intent = {
                intentname: '',
                q_type: 'text',
                a_type: 'json',
                q_val: '',
                a_val: [[]],
                context_in: '',
                context_out: '',
                postidlist: '',
                exceptpostidlist: ''
              }
              vm.cached_intent = this.welcome_intent
              // vm.cached_intent = Object.assign({}, vm.intent)
            })
          } else {
            data['id'] = this.welcome_intent.id
            vm.$store.dispatch('loading')
            api.editIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$store.dispatch('loading')
            })
            // api.editIntent(data, function(error, response) {
            //   if (error) {
            //     console.error(error)
            //     vm.$store.dispatch('loading')
            //     return
            //   }
            //   vm.$emit('input', data)
            //   // console.log(data)
            //   vm.$emit('saveIntent', data)
            //   console.log('vm.cached_intent',vm.cached_intent)
            //   // console.log('this.welcome_intent',this.welcome_intent)
            //   // vm.cached_intent = this.welcome_intent
            //   vm.cached_intent = Object.assign({}, vm.intent)
            //   console.log('error')
            //   vm.$store.dispatch('loading')
            // })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    settingSummit: function() {
      this.saveIntent()
      this.$emit('getWelcomeMessage')
      this.toggleModalSetting()
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        console.log('value', value)
        this.dragLoad = true
      }
    }
  },
  filters: {
    splitimg: function(value) {
      return value.split(';;')
    }
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
}
.box-layout {
  width: 100%;
}
.text-error {
  color: red;
}
.text-area-focus {
  border: 1px solid #0c2f53;
  border-radius: 6px;
}
.box-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
}
.button-inputButtonType {
  height: 37px;
  width: 300px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  padding-left: 14px;
  padding-right: 14px;
  color: #0c2f53;
  outline: none;
  box-shadow: none !important;
}
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 270px;
  background-color: rgba(238, 238, 238, 1);

  color: rgba(12, 47, 83, 1);
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  right: -250px;
  top: -50px;
  /* left: 100; */
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.message {
  word-break: break-word;
}
.modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px 26px 30px 26px;
  position: fixed;
  top: 40px;
  overflow-x: hidden;
  border-radius: 10px;
  background-color: #fff;
}
.btn-footer {
  display: flex;
  flex-direction: row;
  gap: 14px;
}
.btn-summit {
  background: #0c2f53 !important;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #ffef01 !important;
  font-weight: 700;
  font-size: 16px;
}
.btn-cancel {
  background: #ffffff !important;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #0c2f53 !important;
  font-weight: 700;
  font-size: 16px;
}
.button-editButton {
  background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
  border-radius: 5px;
  width: 188px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
}
.generic-Card {
  width: 241px;
  min-height: 363px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  padding-bottom: 10px;
  margin-right: 20px;
  /* margin-left: 30px; */
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 4px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}
/* PHONE CONTAINERS */
.phone-graphic {
  position: relative;
  width: 330px;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
}
.phone-container-outer {
  position: relative;
  font-family: helvetica;
  font-size: 0.8rem;
  border: 1px solid #8f8f8f;
  border-radius: 40px;
  box-shadow: inset 1px 1px 10px #ddd, inset 1px 1px 3px #8f8f8f, 0 0 6px #1059a5;
  background-color: #000;
}
.phone-container-inner {
  position: relative;
  background: #fff;
  margin: 13px;
  border-radius: 30px;
  overflow: hidden;
}

.phone-container-inner:before {
  content: '';
  position: absolute;
  top: 0;
  background-color: #000;
  width: 110px;
  height: 17px;
  left: calc(50% - 55px);
  border-radius: 0 0 20px 20px;
  z-index: 2;
}
.phone-header {
  position: absolute;
  width: 100%;
  height: 60px;
  top: 0;
  background-color: rgba(48, 62, 87, 1);
}

/* HEADER ICONS AND TIME */
.phone-header-time {
  position: absolute;
  font-size: 0.8rem;
  top: 5px;
  left: 15px;
}
.phone-header-icons {
  position: absolute;
  top: 5px;
  right: 15px;
}
.phone-header-icons .material-icons {
  font-size: 0.9rem;
}
.phone-header-icons .material-icons.battery {
  transform: rotate(90deg);
}
.contact-phone {
  position: absolute;
  font-size: 0.62rem;
  top: 30px;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.contact-phone a {
  color: #000;
}

/* PHONE MESSAGES */
.phone-messages {
  margin-top: 60px;
  padding: 20px;
  height: 470px;
}
.message {
  padding: 5px 10px;
  margin-bottom: 10px;
  border-radius: 10px;
}
.message p {
  position: relative;
  z-index: 5;
  margin: 0;
}
.message-contact {
  position: relative;
  background-color: #eeeeee;
  /* background-color: red; */
  text-align: left;
  margin-right: 20%;
  max-width: 214px;
}

.message-contact:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: -10px;
  height: 0px;
  width: 0px;
  background: #eeeeee;
  /* background: green; */
  border-bottom-right-radius: 15px;
}
.message-contact:after {
  content: '';
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: -4px;
  width: 8px;
  height: 20px;
  background: #eeeeee;
  /* background: blue; */
  border-bottom-right-radius: 20px;
  rotate: 100deg;
  top: 0px;
}



/* PHONE FOOTER */
.phone-footer {
  position: absolute;
  height: 40px;
  bottom: 0;
  width: 100%;
  background-color: #efefef;
}
.phone-footer-icons {
  position: absolute;
  bottom: 3px;
  left: 15px;
  color: #7b838d;
}
.phone-footer-input {
  position: absolute;
  bottom: 7px;
  left: 50px;
  width: 200px;
  border: 1px solid #cfcfd2;
  padding: 3px 10px;
  border-radius: 30px;
}
.phone-footer-input p {
  margin: 0;
  color: #cfcfd2;
}
.tag-box {
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px dotted rgba(189, 189, 189, 1);
  color: rgba(189, 189, 189, 1);
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  height: 25px;
}

.input-box {
  height: 20px !important;
  border-bottom: none !important;
  font-family: 'Sukhumvit' !important;
}
.input-box:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
.tag-box-edit {
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  /* margin-bottom: 8px; */
  border: 1px dotted rgba(189, 189, 189, 1);
  color: black;
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  height: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/ChatbotAnswersMessage.vue